import { render } from "./BeneficiaryProfile.vue?vue&type=template&id=48a0a63e&scoped=true"
import script from "./BeneficiaryProfile.vue?vue&type=script&lang=js"
export * from "./BeneficiaryProfile.vue?vue&type=script&lang=js"

import "./BeneficiaryProfile.vue?vue&type=style&index=0&id=48a0a63e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a0a63e"]])

export default __exports__